export type EncounterAbilityAssignmentDefaults = {
  assignmentGroups?: number
  customGrouping?: string
}

export const encounterAbilityAssignmentDefaultsBySpellId: Record<
  number,
  EncounterAbilityAssignmentDefaults
> = {
  1248983: { assignmentGroups: 4 },
  1248710: { customGrouping: '4' },
}

export const getEncounterAbilityAssignmentDefaults = (
  spellId: number,
): EncounterAbilityAssignmentDefaults => {
  const defaults = encounterAbilityAssignmentDefaultsBySpellId[spellId]
  if (!defaults) {
    return { assignmentGroups: 1 }
  }
  return {
    ...defaults,
    assignmentGroups: defaults.assignmentGroups ?? 1,
  }
}

export const getEncounterAbilityAssignmentGroups = (spellId: number) =>
  getEncounterAbilityAssignmentDefaults(spellId).assignmentGroups ?? 1

export const getEncounterAbilityCustomGrouping = (spellId: number) =>
  getEncounterAbilityAssignmentDefaults(spellId).customGrouping
